// Árbol de rutas — generado manualmente.
// TanStack Router normalmente lo auto-genera; aquí lo escribimos a mano.

import { Route as rootRoute } from "./routes/__root";
import { Route as IndexRoute } from "./routes/index";
import { Route as MetodoRoute } from "./routes/metodo";
import { Route as ClasesRoute } from "./routes/clases";
import { Route as ClasesNunoaRoute } from "./routes/clases-calistenia-nunoa";
import { Route as ClasesSanMiguelRoute } from "./routes/clases-calistenia-san-miguel";
import { Route as NosotrosRoute } from "./routes/nosotros";
import { Route as PlanOnlineRoute } from "./routes/plan-online";
import { Route as ArticulosRoute } from "./routes/articulos";
import { Route as ArticuloRoute } from "./routes/articulos.$slug";
import { Route as ContactoRoute } from "./routes/contacto";
import { Route as ProfesionalesConPropositoRoute } from "./routes/profesionales-con-proposito";
import { Route as PrivacidadRoute } from "./routes/privacidad";
import { Route as TerminosRoute } from "./routes/terminos";
import { Route as AdminRoute } from "./routes/admin";
import { Route as StaffRoute } from "./routes/staff";
import { Route as StaffProfesorRoute } from "./routes/staff-profesor";
import { Route as PortalRoute } from "./routes/portal";
import { Route as KidsteniaRoute } from "./routes/kidstenia";
import { Route as PadresRoute } from "./routes/padres";
import { Route as PadresTokenRoute } from "./routes/padres.$token";
import { Route as ProgramaKidsteniaRoute } from "./routes/programa-kidstenia";
import { Route as ProgramaDigitalRoute } from "./routes/programas.$slug";
import { Route as MiProgramaRoute } from "./routes/mi-programa.$slug";
import { Route as PortalProgramaRoute } from "./routes/portal-programa.$slug";
import { Route as PortalHojaDeRutaRoute } from "./routes/portal-hoja-de-ruta.$token";
import { Route as ConsentimientoRoute } from "./routes/consentimiento.$token";
import { Route as HojaDeRutaRoute } from "./routes/hoja-de-ruta.$token";

export const routeTree = rootRoute.addChildren([
  IndexRoute,
  MetodoRoute,
  ClasesRoute,
  ClasesNunoaRoute,
  ClasesSanMiguelRoute,
  NosotrosRoute,
  PlanOnlineRoute,
  ArticulosRoute,
  ArticuloRoute,
  ContactoRoute,
  ProfesionalesConPropositoRoute,
  PrivacidadRoute,
  TerminosRoute,
  AdminRoute,
  StaffRoute,
  StaffProfesorRoute,
  PortalRoute,
  KidsteniaRoute,
  PadresRoute,
  PadresTokenRoute,
  ProgramaKidsteniaRoute,
  ProgramaDigitalRoute,
  MiProgramaRoute,
  PortalProgramaRoute,
  PortalHojaDeRutaRoute,
  ConsentimientoRoute,
  HojaDeRutaRoute,
]);
